var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2939 7.65878C12.9344 6.45249 10.2529 6.56498 7.45277 6.67906C6.81366 6.70875 6.17304 6.73063 5.53237 6.74625V21.1876C6.1652 21.1736 6.78554 21.147 7.39965 21.1204C10.1529 21.0064 12.7999 20.9001 15.2936 21.9611L15.2939 7.65878ZM4.11983 8.91819L3.41981 8.9385L2.66666 8.95882V23.9798C3.53389 23.9595 4.37297 23.9267 5.19956 23.8939C8.99347 23.7345 12.6203 23.5876 16 25.3877C19.3736 23.5876 23.0067 23.7345 26.8004 23.8939C27.627 23.9267 28.4677 23.9611 29.3333 23.9798V8.95882L28.5802 8.9385L27.8801 8.91819V22.5999H27.1739C26.3145 22.5999 25.4207 22.5593 24.541 22.5202C21.6081 22.3999 18.7999 22.2796 16.3546 23.7L15.9999 23.9062L15.6468 23.7062C13.1998 22.2921 10.3934 22.4062 7.46048 22.5265C6.58076 22.5671 5.68696 22.6062 4.82757 22.6062H4.1213V21.8999L4.11983 8.91819ZM26.4675 6.74466V6.74623C25.8269 6.7306 25.1862 6.70872 24.5471 6.67903C21.747 6.56497 19.0673 6.45246 16.706 7.65875V21.9593C19.1999 20.8921 21.847 21.0062 24.5999 21.1187C25.2062 21.1452 25.8265 21.1718 26.4672 21.1858L26.4675 6.74466Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.cdba6eaa1a93a33be9c299e66ee99997.svg";
export { ForwardRef as ReactComponent };